// export const BaseUrl = "https://myomnamoapi.prod.myomnamo.com/Api";
export const BaseUrl = "https://myomnamoapi.prod.myomnamo.com/Api";
export const RazorPayKey = "rzp_live_ar95FhfIcXF0Q2"; // prod : "rzp_live_ar95FhfIcXF0Q2"  test : 'rzp_test_vv1FCZvuDRF6lQ
export const RazorPaySecretKey = "wrI8ZdFFZb6ZuZdOWFrHN9ks";  //RazorPaySecretKey:  wrI8ZdFFZb6ZuZdOWFrHN9ks
export const RazorPayName = 'Myomnamo'

export const GetPhonePayPaymentLink = 'test-phonepe/get-payment-link';
//Test-- '/test-phonepe/get-payment-link'
//PROD-- '/prod-phonepe/get-payment-link'

export const CheckOrderPaymentStatus = 'test-phonepe/check-payment-status'; // PROD---// prod-phonepe/check-payment-status
//Test-- '/test-phonepe/check-payment-status'
//PROD-- '/prod-phonepe/check-payment-status'

